import axios from "axios";
 
// const base_path = getBaseUrl();
const base_path = window.APP_CONFIG?.BASE_URL;


export const getProductAllList = async () => {
    const response = await axios.get(`${base_path}/api/Product/GetAll`);
    return response.data;
  };

  export const getProductbyguid = async (ProdGuId) => {
    const response = await axios.get(`${base_path}/api/Product/GetByGuid?ProdGuId=${ProdGuId}`
    );
    return response.data;
  };
   
   